import type { FaireProductEntity } from "../../entity_types/product";

export const p_cj4wvetg9j: FaireProductEntity = {
  token: "p_cj4wvetg9j",
  type: "product",
  name: "Essentials: Lavender + Bergamot Candle  | 12 oz.",
  brandToken: "b_b19tidse3g",
  brandName: "BOTANICA",
  imageUrl:
    "https://cdn.faire.com/fastly/20f80b5489b39b6d5b3d057f3f5a6e3620f714bbd9e50dd19e76a4b761fa7914.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/36f74fee826e494e5af462c0c19ef45a1d3857e13e9830be85a9d065cc74cb1b.jpeg",
    "https://cdn.faire.com/fastly/82a61d97d0d93659b81699d547d88730a57337fb17b92b8923d195c7288daa4e.jpeg",
    "https://cdn.faire.com/fastly/9dbe4a405ba5ffa8a3e69ea5a58b7f67761d91ef0e5629068ec96c3c699e3a7a.jpeg",
    "https://cdn.faire.com/fastly/a47fd08ba8d7866bca77615be21869433834bb93f12b9a3047b782fed3c91e21.jpeg",
    "https://cdn.faire.com/fastly/7436ceb4e7acdba4b7ac65bef31ab2abf283736a73622dc4f576eec491a3ed5e.jpeg",
  ],
  priceDollars: 22,
  description:
    "A classic combination- Lavender Bergamot combines the soothing notes of lavender with clean and fresh bergamot, making an ideal all-seasons candle for your space. The Botanica Essentials Candle Collection features pure essential oils, balanced with nuanced fragrance oils to create provocative and true-to-nature scents. \n\nFragrance Notes: Lavender, Bergamot, Cedar\n\n• SOY & COCONUT WAX CANDLE | 100% COTTON WICK \n• 12 oz. | 70+ HOUR BURN TIME\n\n\n\n\nKeywords for your SEO:\nessential oil, essential oil candle, natural candle, soy wax, coconut wax, made. inthe usa, made in los angeles, california, botanica, botanica candle, gift candle, best seller, gifts, boutique, candle shop, candle maker, jarred candle, taper candle, gift box candle, colorful candle, rainbow, purple, green, pink, citrus, floral, lavender, bergamot",
  tags: [],
  msrpDollars: 44,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T02:03:54.744Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
